import type { ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { ONBOARDING_ROUTES } from '../routes';

import { TelegramLoginScreen } from './TelegramLoginScreen';
import { useSessionLost } from './use-session-lost';
import { useTelegramLogin } from './use-telegram-login';

/**
 * Route element of E2: wires the login and the lost banner to the screen, and leads to E3 once
 * identified (specs/S4-telegram-login/spec.md R18, R22). It reads no token and no `initData`.
 */
export function TelegramLoginRoute(): ReactElement {
  const navigate = useNavigate();
  const lost = useSessionLost();
  const login = useTelegramLogin({
    onLoggedIn: () => {
      void navigate(ONBOARDING_ROUTES.channels);
    },
  });
  return (
    <TelegramLoginScreen
      view={login.view}
      pending={login.pending}
      newCodeBlockedUntil={login.newCodeBlockedUntil}
      lost={lost}
      onSharePhone={login.sharePhone}
      onTypePhone={login.typePhone}
      onSubmitPhone={login.submitPhone}
      onSubmitCode={login.submitCode}
      onSubmitPassword={login.submitPassword}
      onNewCode={login.newCode}
    />
  );
}
